import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentUserId } from "@/utils";

export class QuotePageReq extends PaginationReq {
  projectId: string | undefined = undefined; // 项目ID
  name: string | undefined = undefined; // 项目名称
  bizNo: string | undefined = undefined; // 报价单编号
  responsibleTenantUserId: string | undefined = undefined; // 投标负责人
  validStatus: string | undefined = undefined; // 报价状态
  flowStatus: string | undefined = undefined; // 审批状态
}

export class QuoteCategoryRecord extends UpdaterResp {
  id: number = 0; // 投标报价ID
  bidNo: string = ""; // 投标报价编号
  projectName: string = ""; // 项目名称
  offerPrice: number = 0; // 投标报价
  responsibleTenantUserId: string = ""; // 投标负责人ID
  responsibleTenantUserName: string = ""; // 投标负责人姓名
  remark: string = ""; // 备注
  validStatus: string = ""; // 生效状态Code
  validStatusName: string = ""; // 生效状态名称
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class QuotePageResp extends PaginationResp<QuoteCategoryRecord> {}

export class CategoryRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  projectFundId: string | undefined = ""; // 工程款项ID
  budget: number | string = ""; // 投标预算
  ratio: number = 0; // 占比
  remark: string = ""; // 备注
}

export class CategoryListResp extends BaseReq {
  records: CategoryRecord[] = [];
}

export class QuoteReq extends BaseReq {
  projectId: string | undefined = undefined; // 项目ID
  offerPrice: string | number = ""; // 投标报价
  responsibleTenantUserId: string | undefined = getCurrentUserId(); // 预算负责人ID
  remark: string = ""; // 备注
  categorys: CategoryRecord[] = []; // 类目明细
  fileList: FileRecord[] = []; //附件
  quantitiesList: QuantityRecord[] = []; //工程量
  materialList: MaterialRecord[] = []; //材料
}

export class CategoryDetailRecord extends CategoryRecord {
  projectFundName: string = ""; // 工程款项名称
}

export class QuoteDetailResp extends UpdaterResp {
  id: string = ""; // 技术方案ID
  bizNo: string = ""; // 技术方案编号
  projectId: string = ""; // 项目ID
  projectName: string = ""; // 项目名称
  offerPrice: number = 0; // 投标报价
  responsibleTenantUserId: string = ""; // 预算负责人ID
  responsibleTenantUserName: string = ""; // 预算负责人姓名
  remark: string = ""; // 备注
  categorys: CategoryRecord[] = []; // 类目明细
  apiList: CategoryDetailRecord[] = []; // 类目明细
}

export class QuantityRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 业务编号
  name: string = ""; // 清单名称
  feature: string = ""; // 项目特征
  unit: string = ""; // 结算单位
  count: number = 0; // 工程量
  price: number = 0; // 综合单价
  totalPrice: number = 0; // 合价
  remark: string = ""; // 备注
}

export class QuantityReq extends BaseReq {
  records: QuantityRecord[] = [];
}

export class QuantityDetailResp {
  records: QuantityRecord[] = [];
}

export class QuantityImportResp {
  records: QuantityRecord[] = [];
}

export class MaterialRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 业务编号
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialBrand: string = ""; // 品牌
  materialModel: string = ""; // 规格型号
  materialUnit: string = ""; // 结算单位
  count: number = 0; // 数量
  price: number = 0; // 单价
  totalPrice: number = 0; // 合价
  remark: string = ""; // 备注
  systemName:string = "";//系统名称
  sortFiled: number = 1;
  materialCategoryName:string = "";//材料分类名称
  materialCategoryId:string = "";//材料分类ID
}

export class MaterialReq extends BaseReq {
  records: MaterialRecord[] = [];
}

export class MaterialDetailResp {
  records: MaterialRecord[] = [];
}

export class MaterialImportResp {
  records: MaterialRecord[] = [];
}
